/**
 * Parse a CSS hex color string (with optional alpha) into a PixiJS fill object. Supports '#RRGGBB', '#RRGGBBAA', 'RRGGBB', 'RRGGBBAA'.
 * @param {string} hex
 * @returns {{ color: number, alpha: number }}
 */
export const parseHexAlpha = hex => {
	if (!hex || typeof hex !== 'string') return { color: 0x000000, alpha: 1 }
	const h = hex.startsWith('#') ? hex.slice(1) : hex
	if (h.length === 8) {
		return { color: parseInt(h.slice(0, 6), 16), alpha: parseInt(h.slice(6, 8), 16) / 255 }
	}
	return { color: parseInt(h, 16) || 0, alpha: 1 }
}
